import React, { useEffect, useRef, useState } from "react";
import { useWindowSize } from "../../hooks/useWindowSize";
import { useAdobeFonts } from "react-adobe-fonts";
import { useLocation, useNavigate } from "react-router-dom";
import { getPaymentInfo } from "./axios";
import {
  PRODUCT_DELIVERY_SELECT_CREDIT_CARD,
  PRODUCT_DELIVERY_ERROR,
  PRODUCT_DELIVERY_COMPLETE_PAYMENT,
  PRODUCT_DELIVERY_START_PAY,
} from "../../routes/path";
import { SpecifiedCommercialModal } from "./SpecifiedCommercialModal";
export const PAYMENT_METHOD = {
  CREDIT_CARD: "01",
};

export default function ProductDeliverySelectPaymentMethod(props) {
  useAdobeFonts({
    kitId: "ict7vce",
  });
  const [, windowHeight] = useWindowSize();
  const [paymentMethod, setPaymentMethod] = useState(
    PAYMENT_METHOD.CREDIT_CARD
  );
  const [receiptedNumber, setReceiptedNumber] = useState("");
  const [paymentId, setPaymentId] = useState("");
  const location = useLocation();
  const [paymentInfo, setPaymentInfo] = useState(null);
  const specifiedCommercialModalRef = useRef(null);
  const openModal = () => {
    specifiedCommercialModalRef.current?.showModal();
  };

  useEffect(() => {
    const getPaymentInfoData = async (paymentIdSrc, receiptedNumberSrc) => {
      const data = await getPaymentInfo(receiptedNumberSrc, paymentIdSrc);
      if (data.data.deleteFlg) {
        // 取消済 画面を切り替える
        navigate(PRODUCT_DELIVERY_ERROR);
      }
      if (data.data.paymentCompletedFlg) {
        // 決済完了している 画面を切り替える
        navigate(PRODUCT_DELIVERY_COMPLETE_PAYMENT);
      }
      setPaymentInfo(data.data);
    };
    // urlからreceiptedNumberを取得
    const search = location.search;
    const query = new URLSearchParams(search);
    const receiptedNumberSrc = query.get("receiptedNumber");
    const paymentIdSrc = query.get("paymentId");
    if (receiptedNumberSrc && paymentIdSrc) {
      setReceiptedNumber(receiptedNumberSrc);
      setPaymentId(paymentIdSrc);
      // 商品を取得する
      getPaymentInfoData(paymentIdSrc, receiptedNumberSrc);
    } else {
      // URL直入力なので画面を切り替える
      navigate(PRODUCT_DELIVERY_ERROR);
    }
  }, []);

  const navigate = useNavigate();
  const nextpage = () => {
    if (paymentMethod === PAYMENT_METHOD.CREDIT_CARD) {
      navigate(PRODUCT_DELIVERY_SELECT_CREDIT_CARD, {
        state: {
          paymentId: paymentId,
          receiptedNumber: receiptedNumber,
          paymentInfo: paymentInfo,
        },
      });
    } else {
      navigate(PRODUCT_DELIVERY_START_PAY, {
        state: {
          paymentId: paymentId,
          receptedNumber: receiptedNumber,
          paymentInfo: paymentInfo,
          selectedPayment: paymentMethod,
        },
      });
    }
  };

  return (
    <div
      className=" tw-max-w-md tw-mx-auto tw-bg-aquahaze-50 tw-relative tk-kozuka-gothic-pr6n"
      style={{ minHeight: windowHeight }}
    >
      <header className=" tw-text-2xl tw-font-bold tw-py-5 tw-bg-white tw-px-4 tw-text-outerspace-800 tw-flex tw-items-center">
        <svg
          className="tw-w-auto tw-h-6 tw-mr-3"
          width="124"
          height="40"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 124 40.52"
        >
          <path
            fill="#23907a"
            d="m0,22.14V4.5c0-.47.14-.61.62-.61.99,0,1.98.01,2.96,0,.37,0,.49.12.49.49-.01,3.66,0,7.31-.02,10.97,0,.39.12.46.48.46,6.05-.01,12.11-.01,18.16,0,.65,0,.67.01.67.67,0,7.83,0,15.67,0,23.5,0,.37-.11.52-.51.52-7.43,0-14.86,0-22.28.02-.46,0-.56-.26-.56-.64v-17.72Zm4.08,14.52c.18,0,.31-.02.44-.02h14.37c.35,0,.45-.08.45-.44-.01-5.36-.01-10.72,0-16.07,0-.34-.08-.47-.45-.47-4.73.01-9.47.01-14.2,0-.6,0-.63.03-.63.64v15.97c0,.12.01.25.02.38"
          />
          <path
            fill="#23907a"
            d="m26.84,28.13c0-3.89,0-7.79,0-11.68,0-.64.01-.65.65-.65h22.25c.87,0,.77-.05.78.77,0,7.73,0,15.47,0,23.2,0,.71,0,.72-.71.72-6.65,0-13.31.01-19.96.01-.81,0-1.61-.01-2.42,0-.43.01-.6-.13-.59-.59.01-3.93,0-7.86,0-11.79m19.56.09h0c0-2.65,0-5.29,0-7.94,0-.53-.08-.61-.61-.61h-14.14c-.61,0-.62,0-.62.63v14.78c0,.4.06.79.04,1.19-.02.34.13.38.42.38,4.81,0,9.63,0,14.44,0,.35,0,.47-.08.47-.46-.02-2.66,0-5.31,0-7.97"
          />
          <path
            fill="#23907a"
            d="m77.1,15.8c.2.66-.29,1-.56,1.41-.51.78-1.06,1.54-1.6,2.3-.61.86-1.24,1.71-1.85,2.58-.74,1.07-1.46,2.15-2.19,3.21-.53.76-1.08,1.51-1.6,2.27-.04.09-.03.2.02.29,1.44,2.16,2.89,4.31,4.34,6.46,1.21,1.8,2.43,3.6,3.62,5.41.09.19.1.4.03.6-.02.08-.28.13-.43.14-1.1.01-2.2-.01-3.3.02-.3.02-.58-.14-.72-.4-.97-1.46-1.95-2.92-2.92-4.39-.9-1.38-1.78-2.78-2.68-4.16-.43-.65-.9-1.27-1.35-1.91-.01-.02-.02-.04-.04-.06-.57-.18-1.19-.08-1.68.26-.77,1.18-1.55,2.34-2.32,3.52-.51.78-1,1.57-1.52,2.35-.59.89-1.19,1.76-1.78,2.64-.37.55-.73,1.1-1.08,1.66-.14.31-.46.51-.8.49-1.12-.03-2.25,0-3.37-.01-.53,0-.69-.24-.41-.66.65-1.01,1.33-2,2-2.99,1.13-1.66,2.27-3.32,3.39-4.98.88-1.29,1.75-2.58,2.6-3.88.07-.14.07-.31,0-.45-.83-1.24-1.66-2.47-2.52-3.69-.89-1.26-1.8-2.5-2.69-3.75-.69-.98-1.36-1.97-2.05-2.96-.16-.2-.31-.41-.43-.64-.07-.18-.09-.38-.06-.57,0-.05.24-.1.38-.1,1.06,0,2.11.01,3.17-.01.46-.05.9.18,1.12.58.81,1.24,1.69,2.42,2.54,3.63.95,1.35,1.9,2.69,2.84,4.04.34.48.64.98,1.01,1.44.16.17.37.29.6.33.66.17,1.35-.16,1.64-.77.83-1.36,1.8-2.63,2.7-3.94,1.02-1.48,2.13-2.91,3.04-4.45.33-.61,1.01-.95,1.7-.84,1.06.01,2.12,0,3.2,0"
          />
          <path
            fill="#23907a"
            d="m96.33,33.89c0-1.9-.02-3.79.01-5.69,0-.85.07-1.7.22-2.53.5-2.65,1.89-5.05,3.93-6.82,1.38-1.25,3.04-2.15,4.84-2.62.82-.21,1.66-.29,2.5-.42.23-.03.46-.03.69,0,.1.03.18.11.2.21.01,1.4,0,2.79,0,4.19,0,.26-.1.36-.37.34-1.3-.05-2.57.32-3.65,1.04-1.13.7-2.06,1.69-2.69,2.86-.61,1.12-.93,2.37-.93,3.65,0,3.93,0,7.85,0,11.78,0,.39-.07.58-.54.56-1.19-.04-2.38-.01-3.58-.02-.5,0-.64-.15-.64-.66v-5.89"
          />
          <path
            fill="#23907a"
            d="m118.81,28.14c0,3.94,0,7.88.01,11.82,0,.43-.13.57-.54.57-1.08-.02-2.16-.01-3.23,0-.26,0-.37-.09-.36-.35,0-.23,0-.45,0-.68,0-7.63,0-15.25,0-22.88,0-1.28-.03-1.01,1.04-1.03.79-.02,1.59,0,2.38,0,.7,0,.71,0,.71.73v11.85h0Z"
          />
          <path
            fill="#23907a"
            d="m111.83,8.65c.03-1.13.57-2.18,1.46-2.87.55-.57,1.08-1.17,1.64-1.73.25-.25.61-.4.85-.65.82-.83,1.59-1.72,2.43-2.52.63-.64,1.52-.96,2.41-.85,1.39.19,2.58,1.1,3.11,2.4.49,1.08.28,2.35-.54,3.21-.73.83-1.54,1.6-2.29,2.42-.4.44-.71.98-1.1,1.43-.61.77-1.28,1.49-2.02,2.14-1.08.99-2.68,1.16-3.94.4-1.29-.62-2.08-1.95-2.02-3.38m11.77-5.03c.07-.57-.09-1.13-.46-1.57-.52-.83-1.35-1.42-2.31-1.65-.64-.17-1.32-.04-1.86.35-.96.84-1.88,1.73-2.76,2.66-.13.1-.15.28-.05.41.02.03.06.06.09.08.33.28.63.59.94.88,1.07,1.02,2.13,2.04,3.2,3.04.1.04.22.03.31-.04.7-.7,1.38-1.41,2.06-2.13.59-.5.9-1.26.83-2.03"
          />
          <path
            fill="#23907a"
            d="m86.39,26.29c1.52,0,3.04,0,4.56,0,.39,0,.56.09.55.53-.03.91,0,1.82,0,2.72,0,.63,0,.63-.65.63h-8.11c-.3,0-.59-.01-.89.01-.33.03-.46-.12-.46-.42,0-1.07.01-2.13,0-3.2,0-.29.18-.26.36-.26h4.64Z"
          />
        </svg>
        お会計
      </header>
      <main className="tw-p-4">
        <p className="tw-text-sm tw-text-outerspace-800">
          金額をご確認のうえ、決済方法を選択してお会計をお願いします。
        </p>
        <div className="tw-bg-white tw-rounded tw-p-4 tw-mt-3">
          <ul className=" tw-space-y-3">
            <li className=" tw-flex tw-justify-between tw-items-center">
              <label className="tw-text-elm-600 tw-text-sm">店名</label>
              <div className="tw-text-outerspace-800 tw-font-bold">
                {paymentInfo && paymentInfo.tenantName}
              </div>
            </li>
            <li className=" tw-flex tw-justify-between tw-items-center">
              <label className="tw-text-elm-600 tw-text-sm">件名</label>
              <div className="tw-text-outerspace-800 tw-font-bold">
                お薬等代金
              </div>
            </li>

            <li>
              <hr className=" tw-border-t-outerspace-100" />
            </li>
            <li className=" tw-flex tw-justify-between tw-items-center">
              <label className="tw-text-elm-600 tw-font-bold">ご請求額</label>
              <div className="tw-flex tw-items-end">
                <span className="tw-text-outerspace-800 tw-font-bold tw-text-2xl">
                  {paymentInfo &&
                    (
                      paymentInfo.accountingAmountWithoutTax +
                      paymentInfo.accountingTax
                    ).toLocaleString()}
                </span>
                <span className="tw-text-slate-500 tw-text-sm tw-ml-1">円</span>
              </div>
            </li>
          </ul>
        </div>
        <ul className="tw-pt-4">
          {paymentInfo &&
            paymentInfo.paymentMethods.map((method, index) => (
              <li key={"paymentMethod-" + index} className="tw-mt-3">
                {method.code === "01" && (
                  <>
                    <button
                      className={`tw-text-sm tw-flex tw-items-center tw-w-full tw-h-16 tw-px-4 tw-font-bold tw-rounded-lg ${
                        paymentMethod === method.code
                          ? " tw-bg-elm-600 tw-text-white"
                          : "tw-text-outerspace-800 tw-bg-white"
                      }`}
                      onClick={() => setPaymentMethod(method.code)}
                    >
                      <div className=" tw-rounded-full tw-bg-white tw-w-5 tw-h-5 tw-flex tw-justify-center tw-items-center tw-mr-2">
                        <svg
                          className={`tw-inline-block tw-w-4 tw-h-4 ${
                            paymentMethod === method.code
                              ? "tw-text-elm-600"
                              : " tw-text-aquahaze-50"
                          }`}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                        >
                          <title>check-bold</title>
                          <path
                            fill="currentColor"
                            d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"
                          />
                        </svg>
                      </div>
                      クレジットカード（一括のみ）
                    </button>
                    <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                      <p className="tw-text-sm">ご利用可能なカード会社</p>
                      <div className=" tw-bg-white tw-p-2 tw-rounded">
                        <img
                          src="/images/credit_cards.png"
                          alt="クレジットカード"
                          className="tw-w-32 tw-h- tw-mx-auto"
                        />
                      </div>
                    </div>
                  </>
                )}
                {method.code !== "01" && (
                  <>
                    <button
                      className={`tw-text-sm tw-flex tw-items-center tw-w-full tw-h-16 tw-px-4 tw-font-bold tw-rounded-lg ${
                        paymentMethod === method.code
                          ? " tw-bg-elm-600 tw-text-white"
                          : "tw-text-outerspace-800 tw-bg-white"
                      }`}
                      onClick={() => setPaymentMethod(method.code)}
                    >
                      <div className=" tw-rounded-full tw-bg-white tw-w-5 tw-h-5 tw-flex tw-justify-center tw-items-center tw-mr-2">
                        <svg
                          className={`tw-inline-block tw-w-4 tw-h-4 ${
                            paymentMethod === method.code
                              ? "tw-text-elm-600"
                              : " tw-text-aquahaze-50"
                          }`}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                        >
                          <title>check-bold</title>
                          <path
                            fill="currentColor"
                            d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"
                          />
                        </svg>
                      </div>
                      {method.name}
                    </button>
                  </>
                )}
              </li>
            ))}
        </ul>
        <div className="tw-flex tw-justify-center tw-items-center tw-mt-6 tw-mb-20">
          <button
            onClick={() => openModal()}
            className="tw-text-blue-700 hover:tw-text-blue-800 hover:tw-underline tw-inline-block tw-p-4"
          >
            特定商取引法に基づく表記
          </button>
        </div>
      </main>
      <footer
        className=" tw-absolute tw-left-0 tw-w-full tw-bg-[#CAE3DE] tw-p-4 tw-flex tw-justify-end"
        style={{ top: windowHeight - 76, position: "fixed" }}
      >
        <button
          onClick={() => nextpage()}
          className=" tw-bg-elm-600 tw-text-white tw-font-bold tw-text-sm tw-py-3 tw-px-4 tw-rounded tw-w-52 tw-transition-colors hover:tw-bg-elm-500"
        >
          次へ
        </button>
      </footer>
      <SpecifiedCommercialModal
        ref={specifiedCommercialModalRef}
        tenantId={paymentInfo ? paymentInfo.tenantId : null}
      />
    </div>
  );
}
